export const DOCUMENT_BLOCK_DRAG_MIME = "application/x-fengyue-blocks";
export const DOCUMENT_BLOCK_DROP_EVENT = "fengyue:document-block-drop";

export interface DocumentBlockDragPayload {
  readonly sourceDocumentId: string;
  readonly blockIds: readonly string[];
}

export function parseDocumentBlockDrag(dataTransfer: DataTransfer): DocumentBlockDragPayload | null {
  try {
    const payload = JSON.parse(dataTransfer.getData(DOCUMENT_BLOCK_DRAG_MIME)) as Partial<DocumentBlockDragPayload>;
    return typeof payload.sourceDocumentId === "string"
      && Array.isArray(payload.blockIds)
      && payload.blockIds.length > 0
      && payload.blockIds.every((id) => typeof id === "string")
      ? { sourceDocumentId: payload.sourceDocumentId, blockIds: payload.blockIds }
      : null;
  } catch {
    return null;
  }
}
